import { useEffect, useRef, useState } from "react";
import "./CustomDropdown.scss";
import { Button } from "react-blueprint-library";

function CustomDropdown({ children }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const toggleShowDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <div id="">
      <div className="desktop-documents-btn-wrapper form-group">
        <div className="dropdown show" ref={dropdownRef}>
          <button
            className="icon-more"
            type="button"
            onClick={toggleShowDropdown}
          ></button>

          <div className={`dropdown-menu ${showDropdown ? "show" : ""}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomDropdown;
